<template>
    <div>
        <div class="columns is-paddingless is-marginless">
            <div class="column is-paddingless">
                <div class="card no-shadow m-l-12">
                    <strong class="is-size-6">Package and Payment information</strong>
                    <div class="card-content p-x-0 p-t-12">
                        <div class="content" v-if="!fetching_payment_package_billinginfo">
                            <div class="row is-clearfix">
                                <div class="col is-pulled-left is-clearfix">
                                    <div class="is-size-7 has-text-grey is-pulled-left">Active package</div>
                                    <div class="has-text-weight-bold is-size-7 has-text-grey is-pulled-left">{{current_subscription}}</div>
                                </div>
                                <div class="col is-pulled-left is-clearfix">
                                    <div class="is-size-7 has-text-grey is-pulled-left">Payment method</div>
                                    <div class="has-text-weight-bold is-size-7 has-text-grey is-pulled-left">{{payment_menthod}}</div>
                                </div>
                                <div class="col is-pulled-left is-clearfix">
                                    <div class="is-size-7 has-text-grey is-pulled-left">Pending package</div>
                                    <div class="has-text-weight-bold is-size-7 has-text-grey is-pulled-left">{{pending_subscription}}</div>
                                </div>
                            </div>

                            <div class="row is-clearfix">
                                <div class="col is-pulled-left is-clearfix">
                                    <div class="is-size-7 has-text-grey is-pulled-left">End date</div>
                                    <div class="has-text-weight-bold is-size-7 has-text-grey is-pulled-left">{{end_date}}</div>
                                </div>
                                <div class="col is-pulled-left is-clearfix is-hidden-mobile">
                                    <div class="is-size-7 has-text-grey is-pulled-left">&nbsp;</div>
                                    <div class="has-text-weight-bold is-size-7 has-text-grey is-pulled-left">&nbsp;</div>
                                </div>
                                <div class="col is-pulled-left is-clearfix">
                                    <div class="is-size-7 has-text-grey is-pulled-left">Activation date</div>
                                    <div class="has-text-weight-bold is-size-7 has-text-grey is-pulled-left">{{activation_date}}</div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="columns is-paddingless is-marginless">
            <div class="column p-x-0 padding-top-0">
                <div class="card no-shadow m-l-12">
                    <strong class="is-size-6">Billing contact details</strong>
                    <div class="card-content p-x-0 p-t-12">
                        <div class="content" v-if="!fetching_payment_package_billinginfo">
                            <div class="row is-clearfix">
                                <div class="col is-pulled-left is-clearfix">
                                    <div class="is-size-7 has-text-grey is-pulled-left">Registered name</div>
                                    <div class="has-text-weight-bold is-size-7 has-text-grey is-pulled-left">{{registered_name}}</div>
                                </div>
                                <div class="col is-pulled-left is-clearfix">
                                    <div class="is-size-7 has-text-grey is-pulled-left">VAT number</div>
                                    <div class="has-text-weight-bold is-size-7 has-text-grey is-pulled-left">{{vat_number}}</div>
                                </div>
                                <div class="col is-pulled-left is-clearfix">
                                    <div class="is-size-7 has-text-grey is-pulled-left">Contact person</div>
                                    <div class="has-text-weight-bold is-size-7 has-text-grey is-pulled-left">{{contact_person}}</div>
                                </div>
                            </div>

                            <div class="row is-clearfix">
                                <div class="col is-pulled-left is-clearfix">
                                    <div class="is-size-7 has-text-grey is-pulled-left">Registration number</div>
                                    <div class="has-text-weight-bold is-size-7 has-text-grey is-pulled-left">{{registration_number}}</div>
                                </div>
                                <div class="col is-pulled-left is-clearfix">
                                    <div class="is-size-7 has-text-grey is-pulled-left">Billing address</div>
                                    <div class="has-text-weight-bold is-size-7 has-text-grey is-pulled-left">{{billing_address}}</div>
                                </div>
                                <div class="col is-pulled-left is-clearfix">
                                    <div class="is-size-7 has-text-grey is-pulled-left">Contact email</div>
                                    <div class="has-text-weight-bold is-size-7 has-text-grey is-pulled-left">{{contact_person_email}}</div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
  /* eslint-disable indent,no-new,no-undef,no-unused-expressions, no-useless-escape */
  import axios from 'axios'

  export default {
    props: {
      businessName: {
        type: String
      }
    },
    data () {
      return {
        fetching_payment_package_billinginfo: false,
        fetching_invoices: false,
        current_subscription: '',
        pending_subscription: '',
        end_date: '',
        payment_menthod: '',
        activation_date: '',
        registered_name: '',
        registration_number: '',
        vat_number: '',
        billing_address: '',
        contact_person: '',
        contact_person_email: ''
      }
    },
    computed: {
      getBusinessSlug () {
        return this.$router.currentRoute.params.slug
      }
    },
    created () {
      this.getPaymentPackageBillingInfo()
    },
    methods: {
      getPaymentPackageBillingInfo () {
        this.fetching_payment_package_billinginfo = true
        axios.get(`/${this.getBusinessSlug}/get-package-payment-billinginfo-details`)
            .then((response) => {
              this.current_subscription = response.data.current_subscription
              this.pending_subscription = response.data.pending_subscription
              this.end_date = response.data.end_date
              this.payment_menthod = response.data.payment_menthod
              this.activation_date = response.data.activation_date
              this.registered_name = response.data.registered_name
              this.registration_number = response.data.registration_number
              this.vat_number = response.data.vat_number
              this.billing_address = response.data.billing_address
              this.contact_person = response.data.contact_person
              this.contact_person_email = response.data.contact_person_email
              this.fetching_payment_package_billinginfo = false
              window.document.title = `Business Portal | Hellopeter - ${this.businessName} (Billing)`
              this.$gtm.trackEvent({
                event: 'pageLoad',
                virtualPageUrl: this.$router.currentRoute.path,
                virtualPageTitle: window.document.title
              })
            })
            .catch(() => {
              this.fetching_payment_package_billinginfo = false
            })
      }
    }
  }
</script>

<style scoped>
    .has-text-weight-bold {
        background: #fff !important;
    }
</style>



// WEBPACK FOOTER //
// src/pages/admin/BusinessBilling.vue